import React from 'react';
import Image from 'next/image';
import format from 'date-fns/format';
import clsx from 'clsx';

import { useIsSender } from 'hooks/useIsSender';
import MessageAttachment from './MessageAttachment';
import styles from 'styles/components/gigs/Chat.module.scss';

const ChatMessage = ({ message, milestone, getMessageBody }) => {
  const isSender = useIsSender(message.sender);

  return (
    <div
      className={clsx(styles.message, {
        [styles.moveRight]: isSender,
      })}
      key={message.id}
    >
      <div
        className={styles.messageBox}
        style={
          isSender
            ? { backgroundColor: 'rgba(163, 119, 254, 0.2)', alignItems: 'flex-end' }
            : { backgroundColor: '#ebedf2', alignItems: 'flex-start' }
        }
      >
        {message.body && <p>{getMessageBody(message.body)}</p>}

        {message.file?.id && <MessageAttachment file={message.file} />}

        {milestone && (
          <div className={styles.milestone}>
            <Image
              width={16}
              height={16}
              src={milestone.network?.active_icon_url}
              alt={milestone.network?.name}
              unoptimized
            />

            <span className={styles.name}>{milestone.name}</span>
          </div>
        )}

        <div className={isSender ? styles.arrowRight : styles.arrowLeft} />
      </div>

      <span className={styles.date}>{format(new Date(message.created_at), 'MMM d, hh:mm a')}</span>
    </div>
  );
};

export default ChatMessage;
